import styled from "styled-components";
import LogoIcon from "./logo.png";

export const StyledLogo = styled.a`
  margin-left: -0.2em;
  font-family: "Roboto", sans-serif;
  display: block;
  background: url(${LogoIcon}) no-repeat;
  background-size: contain;
  text-indent: 2.2em;
  letter-spacing: 1px;
  font-size: 1.9225rem;
  background-position: left center;
  line-height: 200%;
  text-decoration: none;
  color: #424547;
`;

export const SmallLogo = styled(StyledLogo)`
  line-height: 2em;
  font-size: 1.3rem;
`;
